import cn from 'classnames';
import { useIntl } from 'react-intl';
import { Element } from 'react-scroll';

const AziendaCertificazioni = () => {
  const intl = useIntl();
  return (
    <div className="snf-lx-components-azienda-certificazioni">
      <Element name="certificazioni">
        <div className={cn('div-image', `snf-bg-repeat-no-repeat`)} id="Certificazioni">
          <div className="container-fluid px-2 py-5 p-md-5 padding snf-text-color-white">
            <div className="row  ml-1 ml-md-2 mb-2">
              <div className="col-auto snf-font-32 snf-font-w6 mb-3 ">
                {intl.formatMessage({
                  defaultMessage: 'La qualità attraverso l’efficienza'
                })}
              </div>
            </div>

            <div className="row ml-1 ml-md-2 mb-3">
              <div className="col-12  snf-font-24">
                {intl.formatMessage(
                  {
                    defaultMessage: '<strong>Gli standard che evolvono con l’azienda</strong>'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>
            <div className="row ml-1 ml-md-2 mb-4">
              <div className="col-11  snf-font-16">
                {intl.formatMessage(
                  {
                    defaultMessage:
                      'In Sistemi Informativi qualità significa valutare ogni singola prestazione e predisporsi con consapevolezza al <strong>cambiamento</strong>, perché naturale ed insito in tutti i settori di industria in cui operiamo. '
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>

            <div className="row ml-1 ml-md-2 mb-3">
              <div className="col-12  snf-font-24">
                {intl.formatMessage(
                  {
                    defaultMessage: '<strong>Il ciclo della qualità</strong>'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>
            <div className="row ml-1 ml-md-2 mb-3">
              <div className="col-11  snf-font-16">
                {intl.formatMessage(
                  {
                    defaultMessage:
                      'Ogni <strong>prodotto</strong> o <strong>servizio</strong> che presentiamo ai nostri clienti è stato sottoposto a tutti i <strong>processi</strong> necessari per la sua realizzazione, ed ogni processo viene a sua volta riesaminato periodicamente in base agli obiettivi che deve sostenere. '
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>
            <div className="row ml-1 ml-md-2 mb-4">
              <div className="col-11  snf-font-16">
                {intl.formatMessage({
                  defaultMessage:
                    'A supporto della qualità, ogni attore riveste un ruolo fondamentale per la sua riuscita:'
                })}
              </div>
            </div>

            <div className="row ml-1 ml-md-4 justify-content-center mr-4 mb-5">
              <div className="col-10 col-lg-3 greyCard p-3 mb-3 mb-lg-0">
                <div className="row">
                  <div className="col mb-1">
                    {intl.formatMessage(
                      {
                        defaultMessage: '<strong>Il personale qualificato</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col mb-2">
                    {intl.formatMessage({
                      defaultMessage:
                        'Il team esperto di sistemi di gestione, che supporta il ciclo della qualità  grazie ad una pluriennale esperienza e percorsi di formazione costanti.'
                    })}
                  </div>
                </div>
              </div>

              <div className="w-100 d-block d-lg-none" />

              <div className="col-10 col-lg-3 offset-lg-1 greyCard p-3 mb-3 mb-lg-0">
                <div className="row">
                  <div className="col mb-1">
                    {intl.formatMessage(
                      {
                        defaultMessage: '<strong>I nostri professionisti</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col mb-2">
                    {intl.formatMessage({
                      defaultMessage:
                        'che lavorano ogni giorno sulla base di specifici obiettivi riferiti al loro ruolo e alle loro responsabilità.'
                    })}
                  </div>
                </div>
              </div>

              <div className="w-100 d-block d-lg-none" />

              <div className="col-10 col-lg-3 offset-lg-1 greyCard p-3">
                <div className="row">
                  <div className="col mb-1">
                    {intl.formatMessage(
                      {
                        defaultMessage: '<strong>La Direzione</strong>'
                      },
                      {
                        strong: (chunks) => <strong>{chunks}</strong>
                      }
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col mb-2">
                    {intl.formatMessage({
                      defaultMessage:
                        "che comunica puntualmente l'importanza delle nostre certificazioni e assicura che le metodologie e i processi siano compresi, utilizzati e migliorati."
                    })}
                  </div>
                </div>
              </div>
            </div>
            <div className="row ml-1 ml-md-2 mb-3">
              <div className="col-12  snf-font-24">
                {intl.formatMessage(
                  {
                    defaultMessage: '<strong>Certificazioni acquisite</strong>'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>

            <div className="row ml-1 ml-md-4 mb-3 snf-font-16 justify-content-md-start">
              <a
                href="/assets/IBM ITALIA S.P.A  - ISO 9001.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'ISO 9001 - Il sistema di gestione della qualità'
                  })}
                </div>
              </a>
              <a
                href="/assets/Certificate IT340544 SISTEMI INFORMATIVI S.R.L - ISO20000 - VER ITA.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'ISO 20000-1 - Il sistema di gestione dei servizi IT'
                  })}
                </div>
              </a>
              <a
                href="/assets/ISO 27001+27017+27018_merged2025.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'ISO 27001 - La sicurezza delle informazioni (anche in cloud)'
                  })}
                </div>
              </a>
              <a
                href="/assets/CertificazioneISO14001.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'ISO 14001 - Il sistema di gestione ambientale'
                  })}
                </div>
              </a>
              <a
                href="/assets/Certificate IT343878 SISTEMI INFORMATIVI S.R.L 45001 ITA.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'ISO 45001 - Salute e Sicurezza sul Lavoro'
                  })}
                </div>
              </a>
              <a
                href="/assets/SA_8000-ITA-C552824-5-20251107.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'SA8000 - Responsabilità Sociale'
                  })}
                </div>
              </a>
              <a
                href="/assets/Certificazione30415.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'ISO 30415 Diversità e inclusione'
                  })}
                </div>
              </a>
              <a
                href="/assets/UNIPDR125.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'UNI/PDR125 Parità di Genere'
                  })}
                </div>
              </a>
            </div>
            {/* Dichiarazione delle nostre politiche */}
            <div className="row ml-1 ml-md-2 mb-3">
              <div className="col-12  snf-font-24">
                {intl.formatMessage(
                  {
                    defaultMessage: '<strong>Dichiarazione delle nostre politiche</strong>'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>
            <div className="row ml-1 ml-md-4 mb-3 snf-font-16 justify-content-md-start">
              <a
                href="/assets/POL-SSL Sistemi Informativi-2025 v.2.02.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'Politica per la Salute e Sicurezza sul Lavoro'
                  })}
                </div>
              </a>
              <a
                href="/assets/POL-ISMS-SGQ-SGS Sistemi Informativi-Anno 2026 1.10.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage:
                      'Politica per la Qualità, la sicurezza delle informazioni e la gestione dei servizi '
                  })}
                </div>
              </a>
              <a
                href="/assets/POL-SGA Sistemi Informativi-2025-2026-v2.07.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'Politica ambientale'
                  })}
                </div>
              </a>
              <a
                href="/assets/IBM_BCG_2026_ita.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'Guida al comportamento negli affari'
                  })}
                </div>
              </a>
              <a
                href="/assets/condizioni-generali.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-12 col-md-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'Condizioni generali'
                  })}
                </div>
              </a>
              <a
                href="/assets/Report sostenibilita 2021.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-12 col-md-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'Report Sostenibilità 2021'
                  })}
                </div>
              </a>
              <a
                href="/assets/Anti-Corruption_Policy_V2_July-2021_it_SI.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-12 col-md-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'Informativa Anticorruzione'
                  })}
                </div>
              </a>
              <a
                href="/assets/Politica per la Responsabilità Sociale (PRS) v.4.5.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'Politica per la Responsabilità sociale'
                  })}
                </div>
              </a>
              <a
                href="/assets/POL-D&I-PdG Sistemi Informativi-2024-2025 v.3.2.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'Politica per la Diversità e Inclusione e la Parità di Genere'
                  })}
                </div>
              </a>
              <a
                href="/assets/Local Data Protection Laws Covered by the DPAV3.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'Local Data Protection Laws Covered by the DPAV3'
                  })}
                </div>
              </a>
              <a
                href="/assets/Responsabilità sociale conseguimento degli obiettivi 2024.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'Responsabilità Sociale: conseguimento degli obiettivi 2024'
                  })}
                </div>
              </a>
            </div>

            {/* Modello di Organizzazione, Gestione e Controllo ex D. Lgs. 231/2001 */}
            <div className="row ml-1 ml-md-2 mb-3">
              <div className="col-12  snf-font-24">
                {intl.formatMessage(
                  {
                    defaultMessage: '<strong>Modello di Organizzazione, Gestione e Controllo ex D. Lgs. 231/2001</strong>'
                  },
                  {
                    strong: (chunks) => <strong>{chunks}</strong>
                  }
                )}
              </div>
            </div>
            <div className="row ml-1 ml-md-4 mb-3 snf-font-16 justify-content-md-start">
              <a
                href="/assets/SI - MOGC 231 - Parte Generale - 2026 03 26.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage: 'Parte Generale'
                  })}
                </div>
              </a>
              <a
                href="/assets/SI - MOGC 231 - Allegato 1 PG_Reati Presupposto - 2026 03 26.pdf"
                className="snf-color-white"
                target="_blank"
                rel="noreferrer"
              >
                <div className="col-auto blueSquare">
                  {intl.formatMessage({
                    defaultMessage:
                      'Parte Generale – Allegato 1 – Reati presupposto'
                  })}
                </div>
              </a>
            </div>
          </div>
        </div>
      </Element>
    </div>
  );
};

AziendaCertificazioni.displayName = "L'Azienda Organizzazione ";
export { AziendaCertificazioni };
